module.exports = __webpack_public_path__ + "static/media/20.b3705b09.jpg";